import * as THREE from "three";
import { deactivatePosPick, getPosPickState } from "../../../runtime/posPickState";
import { applyPosPickVisuals } from "../../../runtime/posPickVisualBridge";
import { logger } from "../../../utils/logger";

export function ensurePosPickMarker(scene) {
  let marker = scene.getObjectByName("__posPickMarker");
  if (!marker) {
    const geometry = new THREE.SphereGeometry(0.05, 16, 16);
    const material = new THREE.MeshBasicMaterial({
      color: 0xff0000,
      depthTest: false,
      depthWrite: false,
      transparent: true,
      opacity: 0.8,
    });
    marker = new THREE.Mesh(geometry, material);
    marker.name = "__posPickMarker";
    marker.renderOrder = 9999;
    marker.visible = false;
    scene.add(marker);
  }
  if (marker && !getPosPickState().active) {
    marker.visible = false;
  }
  return marker;
}

export function hidePosPickMarker(scene) {
  try {
    const marker = ensurePosPickMarker(scene);
    if (marker) marker.visible = false;
  } catch (error) {
    logger.warn("[Scene] Unexpected error during scene update", error);
  }
}

export function commitPosPick({ bodyObj, bodyUuid, point }) {
  const worldPoint = point.clone();
  const inv = new THREE.Matrix4().copy(bodyObj.matrixWorld).invert();
  const localPoint = worldPoint.clone().applyMatrix4(inv);
  window.dispatchEvent(
    new CustomEvent("pos-picked", {
      detail: {
        bodyUuid,
        world: [worldPoint.x, worldPoint.y, worldPoint.z],
        localToBody: [localPoint.x, localPoint.y, localPoint.z],
      },
    })
  );
  deactivatePosPick();
  applyPosPickVisuals(false);
}

export function updateExpectedBodyPosPickMarker({
  ensureMarker,
  raycaster,
  sceneObjectsRef,
  expectedBodyUuid,
}) {
  const bodyObj = expectedBodyUuid ? sceneObjectsRef.current?.[expectedBodyUuid] : null;
  const marker = ensureMarker();
  if (!bodyObj) {
    marker.visible = false;
    return true;
  }

  const intersects = raycaster.intersectObjects([bodyObj], true);
  if (intersects.length > 0) {
    marker.position.copy(intersects[0].point);
    marker.visible = true;
  } else {
    marker.visible = false;
  }
  return true;
}

export function updatePosPickMarkerFromIntersects({
  ensureMarker,
  getOwningBodyUuidForObject,
  posPickState,
  validIntersects,
}) {
  let targetPoint = null;
  const expectedUuid = posPickState.expectedBodyUuid;
  for (const intersect of validIntersects) {
    const bodyUuid = getOwningBodyUuidForObject(intersect.object);
    if (!bodyUuid) continue;
    if (!expectedUuid || bodyUuid !== expectedUuid) continue;
    targetPoint = intersect.point.clone();
    break;
  }
  const marker = ensureMarker();
  if (targetPoint) {
    marker.position.copy(targetPoint);
    marker.visible = true;
  } else {
    marker.visible = false;
  }
}
